import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import XmotTaskQuestion from "../../../../xmotTaskQuestion/XmotTaskQuestion";
import { useEffect, useRef, useState } from "react";
import {
  expectedXmotLength,
  calculateTotalTime,
} from "../../../../../utils/constants";
import {
  uploadTaskImage,
  uploadTaskVideo,
} from "../../../../../services/xmotSurvey/survey";
import { ProgressSpinner } from "primereact/progressspinner";
import { isEmptyCheck } from "../../../../../utils/commonLogics";
const InstructionsAndTaskQuestion = ({
  errors,
  xmotFormData,
  handleXmotFormChange,
  taskQuestionItems,
  setTaskQuestionItems,
  clientId,
  projectId,
  token,
  onDeleteTaskQuestion,
  deleteTQLoading,
  onDeleteSkipLogic,
  triggerType,
  loading,
  isLocked,
  onDeleteTaskQuestionBlock,
}) => {
  const {
    instructions,
    expectedDuration,
    expectedSessionDuration,
    surveyType,
  } = xmotFormData;
  const errorRef = useRef({});

  useEffect(() => {
    handleXmotFormChange("taskQuestion", taskQuestionItems);
    const selected = getSessionDuration();
    const totalExpDurationTime = calculateTotalTime(selected);
    handleXmotFormChange("expectedSessionDuration", {
      minutes: totalExpDurationTime?.minutes,
      seconds: totalExpDurationTime?.seconds,
    });
    handleXmotFormChange(
      "sessionDurationTime",
      totalExpDurationTime?.totalSeconds,
    );
  }, [taskQuestionItems]);

  useEffect(() => {
    const firstErrorKey =
      errors &&
      Object.keys(errors).length > 0 &&
      !isEmptyCheck(Object.values(errors)[0])
        ? Object.keys(errors)[0]
        : null;

    if (firstErrorKey) {
      const el = errorRef.current[firstErrorKey];
      if (el) {
        el?.scrollIntoView({ behavior: "smooth", block: "center" });
        el?.focus();
      }
    }
  }, [errors]);

  const getSessionDuration = () => {
    let selectedDurations = [];

    for (let item of taskQuestionItems) {
      // Handle task type
      if (item.type === "task") {
        selectedDurations.push(item.taskDuration);

        // Check subTaskQues
        for (let subItem of item?.subTaskQues) {
          selectedDurations.push(subItem?.quesDuration);
        }
      }

      // Handle question type
      if (item.type === "question") {
        selectedDurations.push(item.quesDuration);
      }
    }

    return selectedDurations;
  };

  const onImageUpload = (imgFile, uploadtype, cb) => {
    const reqBody = new FormData();

    reqBody.append("id", clientId);
    reqBody.append("pid", projectId);
    reqBody.append("files", imgFile);

    uploadTaskImage(token, reqBody)
      .then((response) => {
        if (response?.status === 500) {
          cb(true, response?.error || "Internal Server Error", "");
          return;
        }

        if (response?.data?.success) {
          cb(false, "", response?.data?.url);
        } else if (response?.data?.msg) {
          cb(true, response?.data?.msg, "");
        }
      })
      .catch((error) => {
        if (error?.response?.status === 500) {
          cb(true, error?.response?.data?.error || "Internal Server Error", "");
        } else {
          cb(true, error?.response?.data?.msg || "Something went wrong", "");
        }
      });
  };

  const onVideoUpload = (imgFile, cb) => {
    const reqBody = new FormData();

    reqBody.append("id", clientId);
    reqBody.append("pid", projectId);
    reqBody.append("files", imgFile);

    uploadTaskVideo(token, reqBody)
      .then((response) => {
        if (response?.status === 500) {
          cb(true, response?.error || "Internal Server Error", "");
          return;
        }

        if (response?.data?.success) {
          cb(false, "", response?.data?.url);
        } else if (response?.data?.msg) {
          cb(true, response?.data?.msg, "");
        }
      })
      .catch((error) => {
        if (error?.response?.status === 500) {
          cb(true, error?.response?.data?.error || "Internal Server Error", "");
        } else {
          cb(true, error?.response?.data?.msg || "Something went wrong", "");
        }
      });
  };

  return (
    <div className="mt-4 text-start">
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="4"
            animationDuration="0.5s"
          />
        </div>
      )}
      <p className="heading text_dark fw-600 fs-18">Instructions</p>
      <div className="d-flex flex-column mb-3" id="instructionContainer">
        <label className="mb-1 text-start" style={{ color: "#666666" }}>
          Participant Instructions for this XMOT:
        </label>
        <div className="d-flex align-items-center w-100">
          <Editor
            className={`inputField fs-14 ${errors?.instructionsErr ? "error-input" : ""}`}
            value={instructions}
            onTextChange={(e) => {
              handleXmotFormChange("instructions", e.htmlValue);
            }}
            style={{
              height: "150px",
              textAlign: "left",
              width: "100%",
            }}
          />
        </div>
        {errors?.instructionsErr ? (
          <div
            className="text-start fs-14 text-danger mb-1"
            ref={(el) => (errorRef.current.instructionsErr = el)}
          >
            {errors?.instructionsErr}
          </div>
        ) : (
          ""
        )}
      </div>
      <Divider />

      <div className="">
        {taskQuestionItems.length === 0 && errors?.taskQuestionErr ? (
          <div className="text-danger mt-2">{errors?.taskQuestionErr}</div>
        ) : (
          ""
        )}
        <XmotTaskQuestion
          setTaskquestion={setTaskQuestionItems}
          taskQuestion={taskQuestionItems}
          onImageUpload={onImageUpload}
          onVideoUpload={onVideoUpload}
          onDeleteTaskQuestion={onDeleteTaskQuestion}
          onDeleteTaskQuestionBlock={onDeleteTaskQuestionBlock}
          deleteTQLoading={deleteTQLoading}
          onDeleteSkipLogic={onDeleteSkipLogic}
          isLocked={isLocked}
          surveyType={surveyType}
        />
      </div>

      {taskQuestionItems?.length ? (
        <>
          <div className="text-start mb-3">
            <span style={{ color: "#666666" }}>Total Session Duration:</span>
            <span className="text-dark fw-600 ms-2">
              {expectedSessionDuration?.minutes ?? 0} minute{" "}
              {expectedSessionDuration?.seconds ?? 0} Seconds
            </span>
          </div>
          <Divider />
        </>
      ) : (
        <>
          <div className="row mb-3">
            <div className="col-md-3 text-start">
              <div className="form-label mb-2 text-dark fw-600 fs-14">
                Expected XMOT Length:
              </div>
              <Dropdown
                value={expectedDuration}
                onChange={(e) => {
                  handleXmotFormChange("expectedDuration", e.value);
                }}
                options={expectedXmotLength}
                optionLabel="name"
                placeholder="Select Length"
                className={`w-75 inputField ${errors?.expectedDurationErr ? "error-input" : ""}`}
              />
              {errors?.expectedDurationErr ? (
                <div className="text-start fs-14 text-danger mb-1">
                  {errors?.expectedDurationErr}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <Divider />
        </>
      )}
    </div>
  );
};

export default InstructionsAndTaskQuestion;
